export type Home = { id: string; name: string; isDefault: boolean };
export type Space = { id: string; homeId: string; name: string; kind: string; icon: string };

export type FoodEntry = {
  barcode: string;
  name: string;
  quantity: number;
  unit: string;
  homeId: string;
  spaceId: string;
  purchaseDate: string;
  useByDate: string;
  notes: string;
  category: string;
};

export type FoodRecord = Omit<FoodEntry, "barcode"> & { id: string; barcode?: string };

export const QUANTITY_UNITS = ["each", "package", "box", "bag", "bottle", "jar", "can", "carton", "tube", "pouch", "roll", "dozen", "oz", "lb", "kg", "g", "L", "mL"];
export const FOOD_CATEGORIES = ["Produce", "Dairy", "Meat", "Seafood", "Frozen", "Pantry", "Beverages", "Snacks", "Baking", "Condiments", "Spices", "Prepared Meals", "Baby", "Pet", "Other"];
